import ENV from 'config/environment';

export default () => ENV.I18N_ENABLED === 'true';
